import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GroupLinkService } from '../services/group-links.service';

export const groupLinksResolver = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const groupLinkService = inject(GroupLinkService);

  let page = 1;

  if (route.queryParams['page']) {
    page = route.queryParams['page'];
  }

  return groupLinkService.getAll$(page).pipe(
    map(groupLinksList => {
      return {
        groupLinksList: groupLinksList,
      };
    }),
    catchError(error => {
      router.navigate(['/dashboard']);
      return of({ list: null, error });
    })
  );
};
